import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Импортируем иконки
import iconBlue from './img/marker-icon-2x-blue.png';
import iconGold from './img/marker-icon-2x-gold.png';
import iconRed from './img/marker-icon-2x-red.png';
import iconGreen from './img/marker-icon-2x-green.png';
import iconOrange from './img/marker-icon-2x-orange.png';
import iconYellow from './img/marker-icon-2x-yellow.png';
import iconViolet from './img/marker-icon-2x-violet.png'; // Используем для текущего пользователя
import iconGrey from './img/marker-icon-2x-grey.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import YouAreHere from './img/YouAreHere.png';

const statusIcons = {
    'Открыта': iconBlue,
    'Закрыта': iconGreen,
    'Не доставлено': iconRed,
    'Не доставлен': iconRed,
    'В процессе': iconOrange,
    'Ожидает': iconYellow,
};

const MapComponent = ({ center, zoom, receipts, onMarkerClick, userLocation, allowedUsersLocations }) => {
    return (
        <MapContainer
            center={center}
            zoom={zoom}
            style={{ height: '100%', width: '100%' }}
            attributionControl={false} // Отключаем надпись Leaflet
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="" // Убираем надпись OpenStreetMap
            />
            {/* Маркеры для чеков */}
            {receipts && receipts.map(receipt => {
                const status = receipt.status;
                const iconUrl = statusIcons[status] || iconGrey; // Если статус не найден, используем серую иконку
                const customIcon = new L.Icon({
                    iconUrl: iconUrl,
                    shadowUrl: iconShadow,
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41],
                });
                return (
                    <Marker
                        key={receipt.id}
                        position={[parseFloat(receipt.latitude), parseFloat(receipt.longitude)]}
                        icon={customIcon}
                        eventHandlers={{
                            click: () => onMarkerClick(receipt.id),
                        }}
                    >
                        <Popup>
                            <div>
                                <p><b>Чек:</b> {receipt.receipt_number}</p>
                                <p><b>Статус:</b> <span style={{ color: getStatusColor(status) }}>{receipt.status}</span></p>
                                <p><b>Клиент:</b> {receipt.client_name}</p>
                                <p><b>Адрес:</b> {receipt.delivery_address}</p>
                            </div>
                        </Popup>
                    </Marker>
                );
            })}

            {/* Маркер для текущего местоположения пользователя */}
            {userLocation && (
                <Marker
                    position={userLocation}
                    icon={new L.Icon({
                        iconUrl: YouAreHere, // Иконка для вашего местоположения
                        iconSize: [50, 50],
                        iconAnchor: [15, 30],
                    })}
                >
                    <Popup>Вы здесь</Popup>
                </Marker>
            )}

            {/* Маркеры для локаций разрешённых пользователей */}
            {allowedUsersLocations &&
                Object.keys(allowedUsersLocations).map(userId => {
                    const loc = allowedUsersLocations[userId];
                    return (
                        <Marker
                            key={`allowed-${userId}`}
                            position={[loc.lat, loc.lng]}
                            icon={new L.Icon({
                                iconUrl: iconGold, // Иконка для разрешённых пользователей
                                shadowUrl: iconShadow,
                                iconSize: [25, 41],
                                iconAnchor: [12, 41],
                                popupAnchor: [1, -34],
                                shadowSize: [41, 41],
                            })}
                        >
                            <Popup>Пользователь {userId}</Popup>
                        </Marker>
                    );
                })}
        </MapContainer>
    );

    function getStatusColor(status) {
        switch (status) {
            case 'Открыта': return 'blue';
            case 'Закрыта': return 'green';
            case 'Не доставлено': return 'red';
            case 'Не доставлен': return 'red';
            case 'В процессе': return 'orange';
            case 'Ожидает': return 'yellow';
            default: return 'gray';
        }
    }
};

export default MapComponent;
